<template>
  <div class="form-container">
    <div style="margin-left: 80px">
      <el-tabs class="tfam-custom-tabs" v-model="currentLang">
        <el-tab-pane
          v-for="(lang) in langList"
          :key="lang['language_key']"
          :label="lang['title']"
          :name="lang['language_key']"></el-tab-pane>
      </el-tabs>
    </div>
    <el-form v-if="level" ref="form" :model="level" label-width="140px" label-position="left">
      <el-form-item label="標題">
        <el-input v-model="level[currentLang]['title']"></el-input>
      </el-form-item>
      <el-form-item label="副標題">
        <el-input v-model="level[currentLang]['sub_title']"></el-input>
      </el-form-item>
      <el-form-item label="簡介">
        <el-input
          type="textarea"
          :autosize="{ minRows: 5 }"
          v-model="level[currentLang]['introduction']"></el-input>
      </el-form-item>
      <el-form-item v-if="level['index_sort'] < 6" label="iBeacon Tip">
        <el-input
          type="textarea"
          :autosize="{ minRows: 3 }"
          v-model="level[currentLang]['beacon_tip']"></el-input>
      </el-form-item>
      <div v-if="level['index_sort'] === 1">
        <el-form-item label="飛機文案">
          <el-input
            type="textarea"
            :autosize="{ minRows: 6 }"
            v-model="level[currentLang]['tip_object']['tip_one']"></el-input>
        </el-form-item>
      </div>
      <div v-else-if="level['index_sort'] === 2">
        <el-form-item label="拼圖文案">
          <el-input
            type="textarea"
            :autosize="{ minRows: 6 }"
            v-model="level[currentLang]['tip_object']['tip_one']"></el-input>
        </el-form-item>
      </div>
      <div v-else-if="level['index_sort'] === 3">
        <el-form-item label="首獎真心話">
          <el-input
            type="textarea"
            :autosize="{ minRows: 6 }"
            v-model="level[currentLang]['tip_object']['tip_one']"></el-input>
        </el-form-item>
        <el-form-item label="酒瓶遊戲提示">
          <el-input
            type="textarea"
            :autosize="{ minRows: 6 }"
            v-model="level[currentLang]['tip_object']['tip_two']"></el-input>
        </el-form-item>
        <el-form-item label="酒瓶遊戲結果">
          <div v-for="reward in level[currentLang]['tip_object']['rewards']" :key="'reward' + reward['index']" class="level-reward">
            <div class="reward-title">
              <span>結果_{{ reward['index'] }}</span>
            </div>
            <div class="reward-content">
              <div class="reward-info">
                <el-input v-model="reward['title']"></el-input>
                <el-input
                  style="margin-top: 5px"
                  type="textarea"
                  resize="none"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  v-model="reward['description']"></el-input>
              </div>
              <div v-if="currentLang === 'ZH_TW'" class="reward-image">
                <div class="image-content list-image demo-image__error">
                  <div class="block">
                    <el-image :src="getRewardImage(reward['image'])" fit="cover">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </div>
                  <input :id="'fileInput_' + reward['index']" type="file" @change="onImagesChange" accept="image/jpeg, image/png" hidden>
                </div>
                <div class="image-control">
                  <el-button @click="handleUploadImage('fileInput_' + reward['index'])">{{ reward['image']['name'].length > 0 ? reward['image']['original_name'] : '選擇檔案' }}</el-button>
                  <el-button v-if="rewardFiles['fileInput_' + reward['index']].length > 0" plain @click="removeUploadImage('fileInput_' + reward['index'])">移除所選檔案</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
      </div>
      <div v-else-if="level['index_sort'] === 4">
        <el-form-item label="白頭翁提示">
          <el-input
            v-model="level[currentLang]['tip_object']['tip_one']"></el-input>
        </el-form-item>
        <el-form-item label="白頭翁文案">
          <el-input
            type="textarea"
            :autosize="{ minRows: 6 }"
            v-model="level[currentLang]['tip_object']['tip_two']"></el-input>
        </el-form-item>
      </div>
      <div v-else-if="level['index_sort'] === 5">
        <el-form-item label="掃描提示">
          <el-input
            v-model="level[currentLang]['tip_object']['tip_one']"></el-input>
        </el-form-item>
        <el-form-item label="郭雪湖提示">
          <el-input
            v-model="level[currentLang]['tip_object']['tip_two']"></el-input>
        </el-form-item>
        <el-form-item label="郭雪湖文案">
          <el-input
            type="textarea"
            :autosize="{ minRows: 6 }"
            v-model="level[currentLang]['tip_object']['tip_three']"></el-input>
        </el-form-item>
      </div>
      <div v-else-if="level['index_sort'] === 6">
        <el-form-item label="紅不讓提示">
          <el-input
            v-model="level[currentLang]['tip_object']['tip_one']"></el-input>
        </el-form-item>
        <el-form-item label="紅不讓文案">
          <el-input
            type="textarea"
            :autosize="{ minRows: 6 }"
            v-model="level[currentLang]['tip_object']['tip_two']"></el-input>
        </el-form-item>
      </div>
      <div v-else-if="level['index_sort'] === 7">
        <el-form-item label="貼圖作家名稱">
          <el-input
            v-model="level[currentLang]['tip_object']['tip_one']"></el-input>
        </el-form-item>
        <el-form-item v-show="currentLang === 'ZH_TW'" label="貼圖">
          <el-upload
            action=""
            :file-list="uploadStickerImages"
            :auto-upload="false"
            list-type="picture-card"
            class="tfam-upload"
            :on-change="handleStickerFileChange"
            accept="image/*"
            multiple>
            <i class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}" style="width: 100%; height: 100%;">
              <img
                class="el-upload-list__item-thumbnail"
                style="object-fit: contain"
                :src="file.url" alt="">
              <div class="picture-card-style-control">
                <span class="file-name">{{ file.name }}</span>
                <span
                  class="remove-button"
                  @click="handleStickerRemoveFile(file)">
                <i class="el-icon-delete"></i>
              </span>
              </div>
            </div>
          </el-upload>
          <!--
          <div :style="{ marginTop: uploadStickerImages.length > 0 ? '0' : '20px'}">
            <el-button plain @click="removeStickerUploadImage">移除所選檔案</el-button>
          </div>
          -->
        </el-form-item>
      </div>
      <el-form-item v-if="jsonEditVisible" label="Tip Object">
        <v-jsoneditor v-model="level[currentLang]['tip_object']" height="400px" disabled></v-jsoneditor>
      </el-form-item>
      <el-form-item>
        <el-button class="tfam-button" plain @click="jsonEditVisible = !jsonEditVisible">顯示隱藏JSON</el-button>
        <el-button class="tfam-button" v-loading.fullscreen.lock="fullLoading" plain @click="handleSubmitUpdate">更新並儲存</el-button>
        <el-button class="tfam-button" plain @click="goBack">返回至上一層</el-button>
        <!--
        <el-button class="tfam-button" plain @click="handleDeleteRow">捨棄這筆資料</el-button>
        -->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import { fetchLevel, createLevel, updateLevel, createLevelLang, updateLevelLang, deleteLevel, deleteLevelLang } from "../../api/level";
  import lodash from 'lodash'
  import VJsoneditor from 'v-jsoneditor/src/index'
  import { storageUploadFiles, getGCPFileUrl } from "../../api/attachment";
  import { createImage, deleteImage } from "../../api/image";

  export default {
    name: "LevelEdit",
    components: {
      VJsoneditor
    },
    data() {
      return {
        langList: this.$store.getters.langList,
        originalLevel: undefined,
        level: undefined,
        levelId: '',
        currentLang: 'ZH_TW',
        fullLoading: false,
        rewardFiles: {
          'fileInput_1': [],
          'fileInput_2': [],
          'fileInput_3': [],
          'fileInput_4': [],
          'fileInput_5': [],
          'fileInput_6': [],
          'fileInput_7': [],
          'fileInput_8': [],
          'fileInput_9': [],
        },
        jsonEditVisible: false,
        uploadStickerImages: [],
      }
    },
    methods: {
      setupUploadImageList() {
        this.uploadStickerImages = [];
        for (const i in this.originalLevel['ZH_TW']['tip_object']['stickers']) {
          const reward = this.originalLevel['ZH_TW']['tip_object']['stickers'][i];
          if (reward['image_id']) {
            setTimeout(() => {
              const uid = new Date().getTime();
              this.uploadStickerImages.push({
                name: reward['original_name'],
                url: getGCPFileUrl(reward['name']),
                uid: uid,
                status: 'success',
                data: reward
              })
            }, 100);
          }
        }
      },
      handleStickerRemoveFile(file) {
        let index = -1;
        for (const i in this.uploadStickerImages) {
          if (this.uploadStickerImages[i]['uid'] === file['uid']) {
            index = parseInt(i);
            break
          }
        }
        if (index >= 0) {
          this.uploadStickerImages.splice(index, 1);
        }
      },
      handleStickerFileChange(file, fileList) {
        this.uploadStickerImages = fileList;
      },
      removeStickerUploadImage() {
        // this.setupUploadImageList();
      },
      getRewardImage(rewardImage) {
        if (rewardImage['file']) {
          return rewardImage['file'];
        } else if (rewardImage['name'].length > 0) {
          return getGCPFileUrl(rewardImage['name'])
        } else {
          return ''
        }
      },
      getImageUrl(imageName) {
        if (imageName.length > 0) {
          return getGCPFileUrl(imageName)
        } else {
          return ''
        }
      },
      onImagesChange(event){
        console.log(event);
        const elementId = event.target.id;
        const index = parseInt(elementId.split('_')[1]);
        const files = event.target.files;
        if (files) {
          const files_count = files.length;
          for (let i = 0; i < files_count; i++){
            const reader = new FileReader();
            reader.onload = (e) => {
              console.log(index);
              console.log(this.level[this.currentLang]);
              for (const i in this.langList) {
                const langKey = this.langList[i]['language_key'];
                this.level[langKey]['tip_object']['rewards'][index - 1]['image'] = {
                  file: e.target.result,
                  name: files[0]['name'],
                  original_name: files[0]['name']
                }
              }
              this.rewardFiles[elementId] = files;
            };
            reader.readAsDataURL(files[i]);
          }
        }
      },
      handleUploadImage(elementId) {
        document.getElementById(elementId).click()
      },
      removeUploadImage(elementId) {
      },
      getLevelData() {
        const filter = {
          include: ['levelLangs']
        };
        fetchLevel(this.levelId, filter).then(response => {
          const levelData = response.data;
          this.langList.forEach(lang => {
            const key = lang['language_key'];
            const filter = levelData['levelLangs'].filter(x => x['language_key'] === lang['language_key']);
            if (filter.length > 0) {
              levelData[key] = filter[0]
            } else {
              levelData[key] = {
                level_lang_id: 'new',
                language_key: key,
                title: '',
                sub_title: '',
                introduction: '',
                beacon_tip: '',
                tip_object: {},
                level_id: this.levelId
              };
            }
          });
          console.log(levelData);
          this.level = lodash.cloneDeep(levelData);
          this.originalLevel = lodash.cloneDeep(levelData);
          if (levelData['index_sort'] === 7) {
            this.setupUploadImageList()
          }
        }).catch(e => {
        })
      },
      handleSubmitUpdate() {
        this.fullLoading = true;
        this.submitUpdate().then(response => {
          if (this.levelId === 'new') {
            this.levelId = response;
            this.$router.push({
              path: '/levels/' + this.levelId
            });
          }
          this.getLevelData();
          this.fullLoading = false;
        }).catch(err => {
          console.log(err);
          this.fullLoading = false;
        })
      },
      submitUpdate: async function() {
        try {
          const levelData = lodash.cloneDeep(this.level);
          console.log(levelData);
          let levelId = levelData['level_id'];
          if (this.level['index_sort'] === 3) {
            for (let i = 1; i <= 9; i++) {
              if (this.rewardFiles['fileInput_' + i].length > 0) {
                const uploadResult = await storageUploadFiles(this.rewardFiles['fileInput_' + i]);
                const files = uploadResult.data.result.files.file;
                const fileName = files[0]['name'];
                const originalFilename = files[0]['originalFilename'];
                if (this.originalLevel['ZH_TW']['tip_object']['rewards'][i - 1]['image']['image_id']) {
                  await deleteImage(this.originalLevel['ZH_TW']['tip_object']['rewards'][i - 1]['image']['image_id']);
                }
                const image = await createImage({
                  name: fileName,
                  original_name: originalFilename,
                  object_id: levelId
                });
                console.log(image.data);
                for (const langIndex in this.langList) {
                  const langKey = this.langList[langIndex]['language_key'];
                  levelData[langKey]['tip_object']['rewards'][i - 1]['image'] = image.data;
                }
              }
            }
          }
          else if (this.level['index_sort'] === 7) {
            let saveImageList = [];
            for (const i in this.uploadStickerImages) {
              const image = this.uploadStickerImages[i];
              if (image['status'] === 'success' && image['data']) {
                saveImageList.push(image['data'])
              } else if (image['raw']) {
                const uploadImageResult = await storageUploadFiles([image['raw']]);
                const files = uploadImageResult.data.result.files.file;
                const newImageData = await createImage({
                  name: files[0]['name'],
                  original_name: files[0]['originalFilename'],
                  object_id: levelId
                });
                saveImageList.push(newImageData.data)
              }
            }
            console.log('DONE');
            console.log('START DELETE IMAGES');
            for (const i in this.originalLevel['ZH_TW']['tip_object']['stickers']) {
              const sticker = this.originalLevel['ZH_TW']['tip_object']['stickers'][i];
              const filterNewImageList = saveImageList.filter(x => x['image_id'] === sticker['image_id']);
              if (filterNewImageList.length === 0) {
                await deleteImage(sticker['image_id'])
              }
            }
            for (const langIndex in this.langList) {
              const langKey = this.langList[langIndex]['language_key'];
              levelData[langKey]['tip_object']['stickers'] = saveImageList;
            }
          }
          if (levelId === 'new') {
            const newLevel = await createLevel(levelData);
            levelId = newLevel.data['level_id'];
          } else {
            await updateLevel(levelId, levelData);
          }
          for (const i in this.langList) {
            const langKey = this.langList[i]['language_key'];
            const levelLangData = levelData[langKey];
            levelLangData['level_id'] = levelId;
            const levelLangId = levelLangData['level_lang_id'];
            if (levelLangId === 'new') {
              await createLevelLang(levelLangData)
            } else {
              await updateLevelLang(levelLangId, levelLangData)
            }
          }
          return Promise.resolve(levelId);
        } catch (e) {
          return Promise.reject(e);
        }
      },
      goBack() {
        this.$router.push({
          path: '/levels'
        })
      },
      handleDeleteRow() {
        if (confirm('確定要捨棄這筆資料嗎？\n(捨棄的資料將無法復原。)')) {
          if (this.levelId === 'new') {
            this.goBack();
          } else {
            this.fullLoading = true;
            this.submitDeleteRowData().then(response => {
              this.fullLoading = false;
              this.goBack();
            }).catch(err => {
              this.fullLoading = false;
            })
          }
        }
      },
      submitDeleteRowData: async function() {
        try {
          const promiseArray = [];
          promiseArray.push(deleteLevel(this.levelId));
          this.langList.forEach(lang => {
            const key = lang['language_key'];
            if (this.level[key]['level_lang_id'] !== 'new') {
              promiseArray.push(deleteLevelLang(this.level[key]['level_lang_id']));
            }
          });
          await Promise.all(promiseArray);
          return Promise.resolve(true);
        } catch (e) {
          return Promise.reject(e);
        }
      }
    },
    mounted() {
      this.levelId = this.$route.params.id;
      if (this.levelId !== 'new') {
        this.getLevelData()
      } else {
        const levelData = {
          level_id: 'new',
          index_sort: 0,
          building_image: '',
          illustration_image: '',
          map_image: ''
        };
        this.langList.forEach(lang => {
          const key = lang['language_key'];
          levelData[key] = {
            level_lang_id: 'new',
            language_key: key,
            title: '',
            sub_title: '',
            introduction: '',
            beacon_tip: '',
            tip_object: {},
            level_id: ''
          }
        });
        this.level = levelData;
        this.originalLevel = lodash.cloneDeep(levelData);
      }
    }
  }
</script>

<style lang="scss">
.level-reward {
  margin-bottom: 10px;
  height: 250px;
  .reward-title {
    width: 100%;
    text-align: center;
    background: black;
    color: white;
    font-weight: bolder;
  }
  .reward-content {
    display: flex;
    margin-top: 5px;
    .reward-image {
      width: calc(100% - 400px);
      margin-left: 10px;
      text-align: center;
      .image-control {
        button {
          width: 100%;
          margin: 5px 0;
        }
      }
    }
    .reward-info {
      width: 400px;
    }
  }
}
</style>
